<template>
  <div>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/build' }">党建专栏</el-breadcrumb-item>
        <el-breadcrumb-item>党建详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <p style="text-align: center; text-indent: 2em">
          <strong style="font-weight: bolder" data-source="cke">高举中国特色社会主义伟大旗帜</strong>
        </p>
        <p style="text-align: center; text-indent: 2em">
          <strong style="font-weight: bolder" data-source="cke">为全面建设社会主义现代化国家而团结奋斗</strong>
        </p>
        <p style="text-align: center; text-indent: 2em">
          <strong style="font-weight: bolder" data-source="cke">——在中国共产党第二十次全国代表大会上的报告</strong>
        </p>
        <p style="text-align: center; text-indent: 2em">（2022年10月16日）</p>
        <p style="text-align: center; text-indent: 2em">
          <strong style="font-weight: bolder" data-source="cke">习近平</strong>
        </p>
        <p>
          10月16日，习近平在中国共产党第二十次全国代表大会上作报告。新华社记者
          饶爱民 摄
        </p>
        <p>同志们：</p>
        <p>现在，我代表第十九届中央委员会向大会作报告。</p>
        <p>
          中国共产党第二十次全国代表大会，是在全党全国各族人民迈上全面建设社会主义现代化国家新征程、向第二个百年奋斗目标进军的关键时刻召开的一次十分重要的大会。
        </p>
        <p>
          大会的主题是：高举中国特色社会主义伟大旗帜，全面贯彻新时代中国特色社会主义思想，弘扬伟大建党精神，自信自强、守正创新，踔厉奋发、勇毅前行，为全面建设社会主义现代化国家、全面推进中华民族伟大复兴而团结奋斗。
        </p>
        <p>
          中国共产党已走过百年奋斗历程。我们党立志于中华民族千秋伟业，致力于人类和平与发展崇高事业，责任无比重大，使命无上光荣。全党同志务必不忘初心、牢记使命，务必谦虚谨慎、艰苦奋斗，务必敢于斗争、善于斗争，坚定历史自信，增强历史主动，谱写新时代中国特色社会主义更加绚丽的华章。
        </p>
        <p>
          <strong style="font-weight: bolder" data-source="cke">一、过去五年的工作和新时代十年的伟大变革</strong>
        </p>
        <p>
          十九大以来的五年，是极不寻常、极不平凡的五年。党中央统筹中华民族伟大复兴战略全局和世界百年未有之大变局，召开七次全会，分别就宪法修改，深化党和国家机构改革，坚持和完善中国特色社会主义制度、推进国家治理体系和治理能力现代化，制定“十四五”规划和二〇三五年远景目标，全面总结党的百年奋斗重大成就和历史经验等重大问题作出决定和决议，就党和国家事业发展作出重大战略部署，团结带领全党全军全国各族人民有效应对严峻复杂的国际形势和接踵而至的巨大风险挑战，以奋发有为的精神把新时代中国特色社会主义不断推向前进。
        </p>
        <p>
          五年来，我们坚持加强党的全面领导和党中央集中统一领导，全力推进全面建成小康社会进程，完整、准确、全面贯彻新发展理念，着力推动高质量发展，主动构建新发展格局，蹄疾步稳推进改革，扎实推进全过程人民民主，全面推进依法治国，积极发展社会主义先进文化，突出保障和改善民生，集中力量实施脱贫攻坚战，大力推进生态文明建设，坚决维护国家安全，防范化解重大风险，保持社会大局稳定，大力度推进国防和军队现代化建设，全方位开展中国特色大国外交，全面推进党的建设新的伟大工程。我们隆重庆祝中国共产党成立一百周年、中华人民共和国成立七十周年，制定第三个历史决议，在全党开展党史学习教育，建成中国共产党历史展览馆，号召全党学习和践行伟大建党精神，在新的征程上更加坚定、更加自觉地牢记初心使命、开创美好未来。特别是面对突如其来的新冠肺炎疫情，我们坚持人民至上、生命至上，坚持外防输入、内防反弹，坚持动态清零不动摇，开展抗击疫情人民战争、总体战、阻击战，最大限度保护了人民生命安全和身体健康，统筹疫情防控和经济社会发展取得重大积极成果。面对香港局势动荡变化，我们依照宪法和基本法有效实施对特别行政区的全面管治权，制定实施香港特别行政区维护国家安全法，落实“爱国者治港”原则，香港局势实现由乱到治的重大转折，深入推进粤港澳大湾区建设，支持香港、澳门发展经济、改善民生、保持稳定。面对“台独”势力分裂活动和外部势力干涉台湾事务的严重挑衅，我们坚决开展反分裂、反干涉重大斗争，展示了我们维护国家主权和领土完整、反对“台独”的坚强决心和强大能力，进一步掌握了实现祖国完全统一的战略主动，进一步巩固了国际社会坚持一个中国的格局。面对国际局势急剧变化，特别是面对外部讹诈、遏制、封锁、极限施压，我们坚持国家利益为重、国内政治优先，保持战略定力，发扬斗争精神，展示不畏强权的坚定意志，在斗争中维护国家尊严和核心利益，牢牢掌握了我国发展和安全主动权。五年来，我们党团结带领人民，攻克了许多长期没有解决的难题，办成了许多事关长远的大事要事，推动党和国家事业取得举世瞩目的重大成就。
        </p>
        <p>
          同志们！十八大召开至今已经十年了。十年来，我们经历了对党和人民事业具有重大现实意义和深远历史意义的三件大事：一是迎来中国共产党成立一百周年，二是中国特色社会主义进入新时代，三是完成脱贫攻坚、全面建成小康社会的历史任务，实现第一个百年奋斗目标。这是中国共产党和中国人民团结奋斗赢得的历史性胜利，是彪炳中华民族发展史册的历史性胜利，也是对世界具有深远影响的历史性胜利。
        </p>
        <p>
          十年前，我们面对的形势是，改革开放和社会主义现代化建设取得巨大成就，党的建设新的伟大工程取得显著成效，为我们继续前进奠定了坚实基础、创造了良好条件、提供了重要保障，同时一系列长期积累及新出现的突出矛盾和问题亟待解决。党内存在不少对坚持党的领导认识模糊、行动乏力问题，存在不少落实党的领导弱化、虚化、淡化问题，有些党员、干部政治信仰发生动摇，一些地方和部门形式主义、官僚主义、享乐主义和奢靡之风屡禁不止，特权思想和特权现象较为严重，一些贪腐问题触目惊心；经济结构性体制性矛盾突出，发展不平衡、不协调、不可持续，传统发展模式难以为继，一些深层次体制机制问题和利益固化藩篱日益显现；一些人对中国特色社会主义政治制度自信不足，有法不依、执法不严等问题严重存在；拜金主义、享乐主义、极端个人主义和历史虚无主义等错误思潮不时出现，网络舆论乱象丛生，严重影响人们思想和社会舆论环境；民生保障存在不少薄弱环节；资源环境约束趋紧、环境污染等问题突出；维护国家安全制度不完善、应对各种重大风险能力不强，国防和军队现代化存在不少短板弱项；香港、澳门落实“一国两制”的体制机制不健全；国家安全受到严峻挑战，等等。当时，党内和社会上不少人对党和国家前途忧心忡忡。面对这些影响党长期执政、国家长治久安、人民幸福安康的突出矛盾和问题，党中央审时度势、果敢抉择，锐意进取、攻坚克难，团结带领全党全军全国各族人民撸起袖子加油干、风雨无阻向前行，义无反顾进行具有许多新的历史特点的伟大斗争。
        </p>
        <p>
          十年来，我们坚持马克思列宁主义、毛泽东思想、邓小平理论、“三个代表”重要思想、科学发展观，全面贯彻新时代中国特色社会主义思想，全面贯彻党的基本路线、基本方略，采取一系列战略性举措，推进一系列变革性实践，实现一系列突破性进展，取得一系列标志性成果，经受住了来自政治、经济、意识形态、自然界等方面的风险挑战考验，党和国家事业取得历史性成就、发生历史性变革，推动我国迈上全面建设社会主义现代化国家新征程。
        </p>
        <p>
          ——我们创立了新时代中国特色社会主义思想，明确坚持和发展中国特色社会主义的基本方略，提出一系列治国理政新理念新思想新战略，实现了马克思主义中国化时代化新的飞跃，坚持不懈用这一创新理论武装头脑、指导实践、推动工作，为新时代党和国家事业发展提供了根本遵循。
        </p>
        <p>
          ——我们全面加强党的领导，明确中国特色社会主义最本质的特征是中国共产党领导，中国特色社会主义制度的最大优势是中国共产党领导，中国共产党是最高政治领导力量，坚持党中央集中统一领导是最高政治原则，系统完善党的领导制度体系，全党增强“四个意识”，自觉在思想上政治上行动上同党中央保持高度一致，不断提高政治判断力、政治领悟力、政治执行力，确保党中央权威和集中统一领导，确保党发挥总揽全局、协调各方的领导核心作用，我们这个拥有九千六百多万名党员的马克思主义政党更加团结统一。
        </p>
        <p>
          ——我们对新时代党和国家事业发展作出科学完整的战略部署，提出实现中华民族伟大复兴的中国梦，以中国式现代化推进中华民族伟大复兴，统揽伟大斗争、伟大工程、伟大事业、伟大梦想，明确“五位一体”总体布局和“四个全面”战略布局，确定稳中求进工作总基调，统筹发展和安全，明确我国社会主要矛盾是人民日益增长的美好生活需要和不平衡不充分的发展之间的矛盾，并紧紧围绕这个社会主要矛盾推进各项工作，不断丰富和发展人类文明新形态。
        </p>
        <p>
          ——我们经过接续奋斗，实现了小康这个中华民族的千年梦想，我国发展站在了更高历史起点上。我们坚持精准扶贫、尽锐出战，打赢了人类历史上规模最大的脱贫攻坚战，全国八百三十二个贫困县全部摘帽，近一亿农村贫困人口实现脱贫，九百六十多万贫困人口实现易地搬迁，历史性地解决了绝对贫困问题，为全球减贫事业作出了重大贡献。
        </p>
        <p>
          ——我们提出并贯彻新发展理念，着力推进高质量发展，推动构建新发展格局，实施供给侧结构性改革，制定一系列具有全局性意义的区域重大战略，我国经济实力实现历史性跃升。国内生产总值从五十四万亿元增长到一百一十四万亿元，我国经济总量占世界经济的比重达百分之十八点五，提高七点二个百分点，稳居世界第二位；人均国内生产总值从三万九千八百元增加到八万一千元。谷物总产量稳居世界首位，十四亿多人的粮食安全、能源安全得到有效保障。城镇化率提高十一点六个百分点，达到百分之六十四点七。制造业规模、外汇储备稳居世界第一。建成世界最大的高速铁路网、高速公路网，机场港口、水利、能源、信息等基础设施建设取得重大成就。我们加快推进科技自立自强，全社会研发经费支出从一万亿元增加到二万八千亿元，居世界第二位，研发人员总量居世界首位。基础研究和原始创新不断加强，一些关键核心技术实现突破，战略性新兴产业发展壮大，载人航天、探月探火、深海深地探测、超级计算机、卫星导航、量子信息、核电技术、新能源技术、大飞机制造、生物医药等取得重大成果，进入创新型国家行列。
        </p>
        <p>
          ——我们以巨大的政治勇气全面深化改革，打响改革攻坚战，加强改革顶层设计，敢于突进深水区，敢于啃硬骨头，敢于涉险滩，敢于面对新矛盾新挑战，冲破思想观念束缚，突破利益固化藩篱，坚决破除各方面体制机制弊端，各领域基础性制度框架基本建立，许多领域实现历史性变革、系统性重塑、整体性重构，新一轮党和国家机构改革全面完成，中国特色社会主义制度更加成熟更加定型，国家治理体系和治理能力现代化水平明显提高。
        </p>
        <p>
          ——我们实行更加积极主动的开放战略，构建面向全球的高标准自由贸易区网络，加快推进自由贸易试验区、海南自由贸易港建设，共建“一带一路”成为深受欢迎的国际公共产品和国际合作平台。我国成为一百四十多个国家和地区的主要贸易伙伴，货物贸易总额居世界第一，吸引外资和对外投资居世界前列，形成更大范围、更宽领域、更深层次对外开放格局。
        </p>
        <p>
          ——我们坚持走中国特色社会主义政治发展道路，全面发展全过程人民民主，社会主义民主政治制度化、规范化、程序化全面推进，社会主义协商民主广泛开展，人民当家作主更为扎实，基层民主活力增强，爱国统一战线巩固拓展，民族团结进步呈现新气象，党的宗教工作基本方针得到全面贯彻，人权得到更好保障。社会主义法治国家建设深入推进，全面依法治国总体格局基本形成，中国特色社会主义法治体系加快建设，司法体制改革取得重大进展，社会公平正义保障更为坚实，法治中国建设开创新局面。
        </p>
        <p>
          ——我们确立和坚持马克思主义在意识形态领域指导地位的根本制度，新时代党的创新理论深入人心，社会主义核心价值观广泛传播，中华优秀传统文化得到创造性转化、创新性发展，文化事业日益繁荣，网络生态持续向好，意识形态领域形势发生全局性、根本性转变。我们隆重庆祝中国人民解放军建军九十周年、改革开放四十周年，隆重纪念中国人民抗日战争暨世界反法西斯战争胜利七十周年、中国人民志愿军抗美援朝出国作战七十周年，成功举办北京冬奥会、冬残奥会，青年一代更加积极向上，全党全国各族人民文化自信明显增强、精神面貌更加奋发昂扬。
        </p>
        <p>
          ——我们深入贯彻以人民为中心的发展思想，在幼有所育、学有所教、劳有所得、病有所医、老有所养、住有所居、弱有所扶上持续用力，人民生活全方位改善。人均预期寿命增长到七十八点二岁。居民人均可支配收入从一万六千五百元增加到三万五千一百元。城镇新增就业年均一千三百万人以上。建成世界上规模最大的教育体系、社会保障体系、医疗卫生体系，教育普及水平实现历史性跨越，基本养老保险覆盖十亿四千万人，基本医疗保险参保率稳定在百分之九十五。及时调整生育政策。改造棚户区住房四千二百多万套，改造农村危房二千四百多万户，城乡居民住房条件明显改善。互联网上网人数达十亿三千万人。人民群众获得感、幸福感、安全感更加充实、更有保障、更可持续，共同富裕取得新成效。
        </p>
        <p>
          ——我们坚持绿水青山就是金山银山的理念，坚持山水林田湖草沙一体化保护和系统治理，全方位、全地域、全过程加强生态环境保护，生态文明制度体系更加健全，污染防治攻坚向纵深推进，绿色、循环、低碳发展迈出坚实步伐，生态环境保护发生历史性、转折性、全局性变化，我们的祖国天更蓝、山更绿、水更清。
        </p>
        <p>
          ——我们贯彻总体国家安全观，国家安全领导体制和法治体系、战略体系、政策体系不断完善，在原则问题上寸步不让，以坚定的意志品质维护国家主权、安全、发展利益，国家安全得到全面加强。共建共治共享的社会治理制度进一步健全，民族分裂势力、宗教极端势力、暴力恐怖势力得到有效遏制，扫黑除恶专项斗争取得阶段性成果，有力应对一系列重大自然灾害，平安中国建设迈向更高水平。
        </p>
        <p>
          ——我们确立党在新时代的强军目标，贯彻新时代党的强军思想，贯彻新时代军事战略方针，坚持党对人民军队的绝对领导，召开古田全军政治工作会议，以整风精神推进政治整训，牢固树立战斗力这个唯一的根本的标准，坚决把全军工作重心归正到备战打仗上来，统筹加强各方向各领域军事斗争，大抓实战化军事训练，大刀阔斧深化国防和军队改革，重构人民军队领导指挥体制、现代军事力量体系、军事政策制度，加快国防和军队现代化建设，裁减现役员额三十万胜利完成，人民军队体制一新、结构一新、格局一新、面貌一新，现代化水平和实战能力显著提升，中国特色强军之路越走越宽广。
        </p>
        <p>
          ——我们全面准确推进“一国两制”实践，坚持“一国两制”、“港人治港”、“澳人治澳”、高度自治的方针，推动香港进入由乱到治走向由治及兴的新阶段，香港、澳门保持长期稳定发展良好态势。我们提出新时代解决台湾问题的总体方略，促进两岸交流合作，坚决反对“台独”分裂行径，坚决反对外部势力干涉，牢牢把握两岸关系主导权和主动权。
        </p>
        <p>
          ——我们全面推进中国特色大国外交，推动构建人类命运共同体，坚定维护国际公平正义，倡导践行真正的多边主义，旗帜鲜明反对一切霸权主义和强权政治，毫不动摇反对任何单边主义、保护主义、霸凌行径。我们完善外交总体布局，积极建设覆盖全球的伙伴关系网络，推动构建新型国际关系。我们展现负责任大国担当，积极参与全球治理体系改革和建设，全面开展抗击新冠肺炎疫情国际合作，赢得广泛国际赞誉，我国国际影响力、感召力、塑造力显著提升。
        </p>
        <p>
          ——我们深入推进全面从严治党，坚持打铁必须自身硬，从制定和落实中央八项规定开局破题，提出和落实新时代党的建设总要求，以党的政治建设统领党的建设各项工作，坚持思想建党和制度治党同向发力，严肃党内政治生活，持续开展党内集中教育，提出和坚持新时代党的组织路线，突出政治标准选贤任能，加强政治巡视，形成比较完善的党内法规体系，推动全党坚定理想信念、严密组织体系、严明纪律规矩。我们持之以恒正风肃纪，以钉钉子精神纠治“四风”，反对特权思想和特权现象，坚决整治群众身边的不正之风和腐败问题，刹住了一些长期没有刹住的歪风，纠治了一些多年未除的顽瘴痼疾。我们开展了史无前例的反腐败斗争，以“得罪千百人、不负十四亿”的使命担当祛疴治乱，不敢腐、不能腐、不想腐一体推进，“打虎”、“拍蝇”、“猎狐”多管齐下，反腐败斗争取得压倒性胜利并全面巩固，消除了党、国家、军队内部存在的严重隐患，确保党和人民赋予的权力始终用来为人民谋幸福。经过不懈努力，党找到了自我革命这一跳出治乱兴衰历史周期率的第二个答案，自我净化、自我完善、自我革新、自我提高能力显著增强，管党治党宽松软状况得到根本扭转，风清气正的党内政治生态不断形成和发展，确保党永远不变质、不变色、不变味。
        </p>
        <p>
          在充分肯定党和国家事业取得举世瞩目成就的同时，必须清醒看到，我们的工作还存在一些不足，面临不少困难和问题。主要有：发展不平衡不充分问题仍然突出，推进高质量发展还有许多卡点瓶颈，科技创新能力还不强；确保粮食、能源、产业链供应链可靠安全和防范金融风险还须解决许多重大问题；重点领域改革还有不少硬骨头要啃；意识形态领域存在不少挑战；城乡区域发展和收入分配差距仍然较大；群众在就业、教育、医疗、托育、养老、住房等方面面临不少难题；生态环境保护任务依然艰巨；一些党员、干部缺乏担当精神，斗争本领不强，实干精神不足，形式主义、官僚主义现象仍较突出；铲除腐败滋生土壤任务依然艰巨，等等。对这些问题，我们已经采取一系列措施加以解决，今后必须加大工作力度。
        </p>
        <p>
          同志们！新时代的伟大成就是党和人民一道拼出来、干出来、奋斗出来的！在这里，我代表中共中央，向全体中国共产党员，向全国各族人民，向各民主党派、各人民团体和各界爱国人士，向香港特别行政区同胞、澳门特别行政区同胞和台湾同胞以及广大侨胞，向关心和支持中国现代化建设的各国朋友，表示衷心的感谢！
        </p>
        <p>
          新时代十年的伟大变革，在党史、新中国史、改革开放史、社会主义发展史、中华民族发展史上具有里程碑意义。走过百年奋斗历程的中国共产党在革命性锻造中更加坚强有力，党的政治领导力、思想引领力、群众组织力、社会号召力显著增强，党同人民群众始终保持血肉联系，中国共产党在世界形势深刻变化的历史进程中始终走在时代前列，在应对国内外各种风险和考验的历史进程中始终成为全国人民的主心骨，在坚持和发展中国特色社会主义的历史进程中始终成为坚强领导核心。中国人民的前进动力更加强大、奋斗精神更加昂扬、必胜信念更加坚定，焕发出更为强烈的历史自觉和主动精神，中国共产党和中国人民正信心百倍推进中华民族从站起来、富起来到强起来的伟大飞跃。改革开放和社会主义现代化建设深入推进，书写了经济快速发展和社会长期稳定两大奇迹新篇章，我国发展具备了更为坚实的物质基础、更为完善的制度保证，实现中华民族伟大复兴进入了不可逆转的历史进程。科学社会主义在二十一世纪的中国焕发出新的蓬勃生机，中国式现代化为人类实现现代化提供了新的选择，中国共产党和中国人民为解决人类面临的共同问题提供更多更好的中国智慧、中国方案、中国力量，为人类和平与发展崇高事业作出新的更大的贡献！
        </p>
        <p>
          <strong style="font-weight: bolder" data-source="cke">二、开辟马克思主义中国化时代化新境界</strong>
        </p>
        <p>
          马克思主义是我们立党立国、兴党兴国的根本指导思想。实践告诉我们，中国共产党为什么能，中国特色社会主义为什么好，归根到底是马克思主义行，是中国化时代化的马克思主义行。拥有马克思主义科学理论指导是我们党坚定信仰信念、把握历史主动的根本所在。
        </p>
        <p>
          推进马克思主义中国化时代化是一个追求真理、揭示真理、笃行真理的过程。十八大以来，国内外形势新变化和实践新要求，迫切需要我们从理论和实践的结合上深入回答关系党和国家事业发展、党治国理政的一系列重大时代课题。我们党勇于进行理论探索和创新，以全新的视野深化对共产党执政规律、社会主义建设规律、人类社会发展规律的认识，取得重大理论创新成果，集中体现为新时代中国特色社会主义思想。十九大、十九届六中全会提出的“十个明确”、“十四个坚持”、“十三个方面成就”概括了这一思想的主要内容，必须长期坚持并不断丰富发展。
        </p>
        <p>
          中国共产党人深刻认识到，只有把马克思主义基本原理同中国具体实际相结合、同中华优秀传统文化相结合，坚持运用辩证唯物主义和历史唯物主义，才能正确回答时代和实践提出的重大问题，才能始终保持马克思主义的蓬勃生机和旺盛活力。
        </p>
        <p>
          坚持和发展马克思主义，必须同中国具体实际相结合。我们坚持以马克思主义为指导，是要运用其科学的世界观和方法论解决中国的问题，而不是要背诵和重复其具体结论和词句，更不能把马克思主义当成一成不变的教条。我们必须坚持解放思想、实事求是、与时俱进、求真务实，一切从实际出发，着眼解决新时代改革开放和社会主义现代化建设的实际问题，不断回答中国之问、世界之问、人民之问、时代之问，作出符合中国实际和时代要求的正确回答，得出符合客观规律的科学认识，形成与时俱进的理论成果，更好指导中国实践。
        </p>
        <p>
          坚持和发展马克思主义，必须同中华优秀传统文化相结合。只有植根本国、本民族历史文化沃土，马克思主义真理之树才能根深叶茂。中华优秀传统文化源远流长、博大精深，是中华文明的智慧结晶，其中蕴含的天下为公、民为邦本、为政以德、革故鼎新、任人唯贤、天人合一、自强不息、厚德载物、讲信修睦、亲仁善邻等，是中国人民在长期生产生活中积累的宇宙观、天下观、社会观、道德观的重要体现，同科学社会主义价值观主张具有高度契合性。我们必须坚定历史自信、文化自信，坚持古为今用、推陈出新，把马克思主义思想精髓同中华优秀传统文化精华贯通起来、同人民群众日用而不觉的共同价值观念融通起来，不断赋予科学理论鲜明的中国特色，不断夯实马克思主义中国化时代化的历史基础和群众基础，让马克思主义在中国牢牢扎根。
        </p>
        <p>
          实践没有止境，理论创新也没有止境。不断谱写马克思主义中国化时代化新篇章，是当代中国共产党人的庄严历史责任。继续推进实践基础上的理论创新，首先要把握好新时代中国特色社会主义思想的世界观和方法论，坚持好、运用好贯穿其中的立场观点方法。
        </p>
        <p>
          ——必须坚持人民至上。人民性是马克思主义的本质属性，党的理论是来自人民、为了人民、造福人民的理论，人民的创造性实践是理论创新的不竭源泉。一切脱离人民的理论都是苍白无力的，一切不为人民造福的理论都是没有生命力的。我们要站稳人民立场、把握人民愿望、尊重人民创造、集中人民智慧，形成为人民所喜爱、所认同、所拥有的理论，使之成为指导人民认识世界和改造世界的强大思想武器。
        </p>
        <p>
          ——必须坚持自信自立。中国人民和中华民族从近代以后的深重苦难走向伟大复兴的光明前景，从来就没有教科书，更没有现成答案。党的百年奋斗成功道路是党领导人民独立自主探索开辟出来的，马克思主义的中国篇章是中国共产党人依靠自身力量实践出来的，贯穿其中的一个基本点就是中国的问题必须从中国基本国情出发，由中国人自己来解答。我们要坚持对马克思主义的坚定信仰、对中国特色社会主义的坚定信念，坚定道路自信、理论自信、制度自信、文化自信，以更加积极的历史担当和创造精神为发展马克思主义作出新的贡献，既不能刻舟求剑、封闭僵化，也不能照抄照搬、食洋不化。
        </p>
        <p>
          ——必须坚持守正创新。我们从事的是前无古人的伟大事业，守正才能不迷失方向、不犯颠覆性错误，创新才能把握时代、引领时代。我们要以科学的态度对待科学、以真理的精神追求真理，坚持马克思主义基本原理不动摇，坚持党的全面领导不动摇，坚持中国特色社会主义不动摇，紧跟时代步伐，顺应实践发展，以满腔热忱对待一切新生事物，不断拓展认识的广度和深度，敢于说前人没有说过的新话，敢于干前人没有干过的事情，以新的理论指导新的实践。
        </p>
        <p>
          ——必须坚持问题导向。问题是时代的声音，回答并指导解决问题是理论的根本任务。今天我们所面临问题的复杂程度、解决问题的艰巨程度明显加大，给理论创新提出了全新要求。我们要增强问题意识，聚焦实践遇到的新问题、改革发展稳定存在的深层次问题、人民群众急难愁盼问题、国际变局中的重大问题、党的建设面临的突出问题，不断提出真正解决问题的新理念新思路新办法。
        </p>
        <p>
          ——必须坚持系统观念。万事万物是相互联系、相互依存的。只有用普遍联系的、全面系统的、发展变化的观点观察事物，才能把握事物发展规律。我国是一个发展中大国，仍处于社会主义初级阶段，正在经历广泛而深刻的社会变革，推进改革发展、调整利益关系往往牵一发而动全身。我们要善于通过历史看现实、透过现象看本质，把握好全局和局部、当前和长远、宏观和微观、主要矛盾和次要矛盾、特殊和一般的关系，不断提高战略思维、历史思维、辩证思维、系统思维、创新思维、法治思维、底线思维能力，为前瞻性思考、全局性谋划、整体性推进党和国家各项事业提供科学思想方法。
        </p>
        <p>
          ——必须坚持胸怀天下。中国共产党是为中国人民谋幸福、为中华民族谋复兴的党，也是为人类谋进步、为世界谋大同的党。我们要拓展世界眼光，深刻洞察人类发展进步潮流，积极回应各国人民普遍关切，为解决人类面临的共同问题作出贡献，以海纳百川的宽阔胸襟借鉴吸收人类一切优秀文明成果，推动建设更加美好的世界。
        </p>
        <p>
          <strong style="font-weight: bolder" data-source="cke">三、新时代新征程中国共产党的使命任务</strong>
        </p>
        <p>
          从现在起，中国共产党的中心任务就是团结带领全国各族人民全面建成社会主义现代化强国、实现第二个百年奋斗目标，以中国式现代化全面推进中华民族伟大复兴。
        </p>
        <p>
          在新中国成立特别是改革开放以来长期探索和实践基础上，经过十八大以来在理论和实践上的创新突破，我们党成功推进和拓展了中国式现代化。
        </p>
        <p>
          中国式现代化，是中国共产党领导的社会主义现代化，既有各国现代化的共同特征，更有基于自己国情的中国特色。
        </p>
        <p>
          ——中国式现代化是人口规模巨大的现代化。我国十四亿多人口整体迈进现代化社会，规模超过现有发达国家人口的总和，艰巨性和复杂性前所未有，发展途径和推进方式也必然具有自己的特点。我们始终从国情出发想问题、作决策、办事情，既不好高骛远，也不因循守旧，保持历史耐心，坚持稳中求进、循序渐进、持续推进。
        </p>
        <p>
          ——中国式现代化是全体人民共同富裕的现代化。共同富裕是中国特色社会主义的本质要求，也是一个长期的历史过程。我们坚持把实现人民对美好生活的向往作为现代化建设的出发点和落脚点，着力维护和促进社会公平正义，着力促进全体人民共同富裕，坚决防止两极分化。
        </p>
        <p>
          ——中国式现代化是物质文明和精神文明相协调的现代化。物质富足、精神富有是社会主义现代化的根本要求。物质贫困不是社会主义，精神贫乏也不是社会主义。我们不断厚植现代化的物质基础，不断夯实人民幸福生活的物质条件，同时大力发展社会主义先进文化，加强理想信念教育，传承中华文明，促进物的全面丰富和人的全面发展。
        </p>
        <p>
          ——中国式现代化是人与自然和谐共生的现代化。人与自然是生命共同体，无止境地向自然索取甚至破坏自然必然会遭到大自然的报复。我们坚持可持续发展，坚持节约优先、保护优先、自然恢复为主的方针，像保护眼睛一样保护自然和生态环境，坚定不移走生产发展、生活富裕、生态良好的文明发展道路，实现中华民族永续发展。
        </p>
        <p>
          ——中国式现代化是走和平发展道路的现代化。我国不走一些国家通过战争、殖民、掠夺等方式实现现代化的老路，那种损人利己、充满血腥罪恶的老路给广大发展中国家人民带来深重苦难。我们坚定站在历史正确的一边、站在人类文明进步的一边，高举和平、发展、合作、共赢旗帜，在坚定维护世界和平与发展中谋求自身发展，又以自身发展更好维护世界和平与发展。
        </p>
        <p>
          中国式现代化的本质要求是：坚持中国共产党领导，坚持中国特色社会主义，实现高质量发展，发展全过程人民民主，丰富人民精神世界，实现全体人民共同富裕，促进人与自然和谐共生，推动构建人类命运共同体，创造人类文明新形态。
        </p>
        <p>
          全面建成社会主义现代化强国，总的战略安排是分两步走：从二〇二〇年到二〇三五年基本实现社会主义现代化；从二〇三五年到本世纪中叶把我国建成富强民主文明和谐美丽的社会主义现代化强国。
        </p>
        <p>
          到二〇三五年，我国发展的总体目标是：经济实力、科技实力、综合国力大幅跃升，人均国内生产总值迈上新的大台阶，达到中等发达国家水平；实现高水平科技自立自强，进入创新型国家前列；建成现代化经济体系，形成新发展格局，基本实现新型工业化、信息化、城镇化、农业现代化；基本实现国家治理体系和治理能力现代化，全过程人民民主制度更加健全，基本建成法治国家、法治政府、法治社会；建成教育强国、科技强国、人才强国、文化强国、体育强国、健康中国，国家文化软实力显著增强；人民生活更加幸福美好，居民人均可支配收入再上新台阶，中等收入群体比重明显提高，基本公共服务实现均等化，农村基本具备现代生活条件，社会保持长期稳定，人的全面发展、全体人民共同富裕取得更为明显的实质性进展；广泛形成绿色生产生活方式，碳排放达峰后稳中有降，生态环境根本好转，美丽中国目标基本实现；国家安全体系和能力全面加强，基本实现国防和军队现代化。
        </p>
        <p>
          在基本实现现代化的基础上，我们要继续奋斗，到本世纪中叶，把我国建设成为综合国力和国际影响力领先的社会主义现代化强国。
        </p>
        <p>
          未来五年是全面建设社会主义现代化国家开局起步的关键时期，主要目标任务是：经济高质量发展取得新突破，科技自立自强能力显著提升，构建新发展格局和建设现代化经济体系取得重大进展；改革开放迈出新步伐，国家治理体系和治理能力现代化深入推进，社会主义市场经济体制更加完善，更高水平开放型经济新体制基本形成；全过程人民民主制度化、规范化、程序化水平进一步提高，中国特色社会主义法治体系更加完善；人民精神文化生活更加丰富，中华民族凝聚力和中华文化影响力不断增强；居民收入增长和经济增长基本同步，劳动报酬提高与劳动生产率提高基本同步，基本公共服务均等化水平明显提升，多层次社会保障体系更加健全；城乡人居环境明显改善，美丽中国建设成效显著；国家安全更为巩固，建军一百年奋斗目标如期实现，平安中国建设扎实推进；中国国际地位和影响进一步提高，在全球治理中发挥更大作用。
        </p>
        <p>
          全面建设社会主义现代化国家，是一项伟大而艰巨的事业，前途光明，任重道远。当前，世界百年未有之大变局加速演进，新一轮科技革命和产业变革深入发展，国际力量对比深刻调整，我国发展面临新的战略机遇。同时，世纪疫情影响深远，逆全球化思潮抬头，单边主义、保护主义明显上升，世界经济复苏乏力，局部冲突和动荡频发，全球性问题加剧，世界进入新的动荡变革期。我国改革发展稳定面临不少深层次矛盾躲不开、绕不过，党的建设特别是党风廉政建设和反腐败斗争面临不少顽固性、多发性问题，来自外部的打压遏制随时可能升级。我国发展进入战略机遇和风险挑战并存、不确定难预料因素增多的时期，各种“黑天鹅”、“灰犀牛”事件随时可能发生。我们必须增强忧患意识，坚持底线思维，做到居安思危、未雨绸缪，准备经受风高浪急甚至惊涛骇浪的重大考验。前进道路上，必须牢牢把握以下重大原则。
        </p>
        <p>
          ——坚持和加强党的全面领导。坚决维护党中央权威和集中统一领导，把党的领导落实到党和国家事业各领域各方面各环节，使党始终成为风雨来袭时全体人民最可靠的主心骨，确保我国社会主义现代化建设正确方向，确保拥有团结奋斗的强大政治凝聚力、发展自信心，集聚起万众一心、共克时艰的磅礴力量。
        </p>
        <p>
          ——坚持中国特色社会主义道路。坚持以经济建设为中心，坚持四项基本原则，坚持改革开放，坚持独立自主、自力更生，坚持道不变、志不改，既不走封闭僵化的老路，也不走改旗易帜的邪路，坚持把国家和民族发展放在自己力量的基点上，坚持把中国发展进步的命运牢牢掌握在自己手中。
        </p>
        <p>
          ——坚持以人民为中心的发展思想。维护人民根本利益，增进民生福祉，不断实现发展为了人民、发展依靠人民、发展成果由人民共享，让现代化建设成果更多更公平惠及全体人民。
        </p>
        <p>
          ——坚持深化改革开放。深入推进改革创新，坚定不移扩大开放，着力破解深层次体制机制障碍，不断彰显中国特色社会主义制度优势，不断增强社会主义现代化建设的动力和活力，把我国制度优势更好转化为国家治理效能。
        </p>
        <p>
          ——坚持发扬斗争精神。增强全党全国各族人民的志气、骨气、底气，不信邪、不怕鬼、不怕压，知难而进、迎难而上，统筹发展和安全，全力战胜前进道路上各种困难和挑战，依靠顽强斗争打开事业发展新天地。
        </p>
        <p>
          同志们！今天，我们比历史上任何时期都更接近、更有信心和能力实现中华民族伟大复兴的目标，同时必须准备付出更为艰巨、更为艰苦的努力。全党必须坚定信心、锐意进取，主动识变应变求变，主动防范化解风险，不断夺取全面建设社会主义现代化国家新胜利！
        </p>
        <p>
          <strong style="font-weight: bolder" data-source="cke">四、加快构建新发展格局，着力推动高质量发展</strong>
        </p>
        <p>
          高质量发展是全面建设社会主义现代化国家的首要任务。发展是党执政兴国的第一要务。没有坚实的物质技术基础，就不可能全面建成社会主义现代化强国。必须完整、准确、全面贯彻新发展理念，坚持社会主义市场经济改革方向，坚持高水平对外开放，加快构建以国内大循环为主体、国内国际双循环相互促进的新发展格局。
        </p>
        <p>
          我们要坚持以推动高质量发展为主题，把实施扩大内需战略同深化供给侧结构性改革有机结合起来，增强国内大循环内生动力和可靠性，提升国际循环质量和水平，加快建设现代化经济体系，着力提高全要素生产率，着力提升产业链供应链韧性和安全水平，着力推进城乡融合和区域协调发展，推动经济实现质的有效提升和量的合理增长。
        </p>
        <p>
          （一）构建高水平社会主义市场经济体制。坚持和完善社会主义基本经济制度，毫不动摇巩固和发展公有制经济，毫不动摇鼓励、支持、引导非公有制经济发展，充分发挥市场在资源配置中的决定性作用，更好发挥政府作用。深化国资国企改革，加快国有经济布局优化和结构调整，推动国有资本和国有企业做强做优做大，提升企业核心竞争力。优化民营企业发展环境，依法保护民营企业产权和企业家权益，促进民营经济发展壮大。完善中国特色现代企业制度，弘扬企业家精神，加快建设世界一流企业。支持中小微企业发展。深化简政放权、放管结合、优化服务改革。构建全国统一大市场，深化要素市场化改革，建设高标准市场体系。完善产权保护、市场准入、公平竞争、社会信用等市场经济基础制度，优化营商环境。健全宏观经济治理体系，发挥国家发展规划的战略导向作用，加强财政政策和货币政策协调配合，着力扩大内需，增强消费对经济发展的基础性作用和投资对优化供给结构的关键作用。健全现代预算制度，优化税制结构，完善财政转移支付体系。深化金融体制改革，建设现代中央银行制度，加强和完善现代金融监管，强化金融稳定保障体系，依法将各类金融活动全部纳入监管，守住不发生系统性风险底线。健全资本市场功能，提高直接融资比重。加强反垄断和反不正当竞争，破除地方保护和行政性垄断，依法规范和引导资本健康发展。
        </p>
        <p>
          （二）建设现代化产业体系。坚持把发展经济的着力点放在实体经济上，推进新型工业化，加快建设制造强国、质量强国、航天强国、交通强国、网络强国、数字中国。实施产业基础再造工程和重大技术装备攻关工程，支持专精特新企业发展，推动制造业高端化、智能化、绿色化发展。巩固优势产业领先地位，在关系安全发展的领域加快补齐短板，提升战略性资源供应保障能力。推动战略性新兴产业融合集群发展，构建新一代信息技术、人工智能、生物技术、新能源、新材料、高端装备、绿色环保等一批新的增长引擎。构建优质高效的服务业新体系，推动现代服务业同先进制造业、现代农业深度融合。加快发展物联网，建设高效顺畅的流通体系，降低物流成本。加快发展数字经济，促进数字经济和实体经济深度融合，打造具有国际竞争力的数字产业集群。优化基础设施布局、结构、功能和系统集成，构建现代化基础设施体系。
        </p>
        <p>
          （三）全面推进乡村振兴。全面建设社会主义现代化国家，最艰巨最繁重的任务仍然在农村。坚持农业农村优先发展，坚持城乡融合发展，畅通城乡要素流动。加快建设农业强国，扎实推动乡村产业、人才、文化、生态、组织振兴。全方位夯实粮食安全根基，全面落实粮食安全党政同责，牢牢守住十八亿亩耕地红线，逐步把永久基本农田全部建成高标准农田，深入实施种业振兴行动，强化农业科技和装备支撑，健全种粮农民收益保障机制和主产区利益补偿机制，确保中国人的饭碗牢牢端在自己手中。树立大食物观，发展设施农业，构建多元化食物供给体系。发展乡村特色产业，拓宽农民增收致富渠道。巩固拓展脱贫攻坚成果，增强脱贫地区和脱贫群众内生发展动力。统筹乡村基础设施和公共服务布局，建设宜居宜业和美乡村。巩固和完善农村基本经营制度，发展新型农村集体经济，发展新型农业经营主体和社会化服务，发展农业适度规模经营。深化农村土地制度改革，赋予农民更加充分的财产权益。保障进城落户农民合法土地权益，鼓励依法自愿有偿转让。完善农业支持保护制度，健全农村金融服务体系。
        </p>
        <p>
          （四）促进区域协调发展。深入实施区域协调发展战略、区域重大战略、主体功能区战略、新型城镇化战略，优化重大生产力布局，构建优势互补、高质量发展的区域经济布局和国土空间体系。推动西部大开发形成新格局，推动东北全面振兴取得新突破，促进中部地区加快崛起，鼓励东部地区加快推进现代化。支持革命老区、民族地区加快发展，加强边疆地区建设，推进兴边富民、稳边固边。推进京津冀协同发展、长江经济带发展、长三角一体化发展，推动黄河流域生态保护和高质量发展。高标准、高质量建设雄安新区，推动成渝地区双城经济圈建设。健全主体功能区制度，优化国土空间发展格局。推进以人为核心的新型城镇化，加快农业转移人口市民化。以城市群、都市圈为依托构建大中小城市协调发展格局，推进以县城为重要载体的城镇化建设。坚持人民城市人民建、人民城市为人民，提高城市规划、建设、治理水平，加快转变超大特大城市发展方式，实施城市更新行动，加强城市基础设施建设，打造宜居、韧性、智慧城市。发展海洋经济，保护海洋生态环境，加快建设海洋强国。
        </p>
        <p>
          （五）推进高水平对外开放。依托我国超大规模市场优势，以国内大循环吸引全球资源要素，增强国内国际两个市场两种资源联动效应，提升贸易投资合作质量和水平。稳步扩大规则、规制、管理、标准等制度型开放。推动货物贸易优化升级，创新服务贸易发展机制，发展数字贸易，加快建设贸易强国。合理缩减外资准入负面清单，依法保护外商投资权益，营造市场化、法治化、国际化一流营商环境。推动共建“一带一路”高质量发展。优化区域开放布局，巩固东部沿海地区开放先导地位，提高中西部和东北地区开放水平。加快建设西部陆海新通道。加快建设海南自由贸易港，实施自由贸易试验区提升战略，扩大面向全球的高标准自由贸易区网络。有序推进人民币国际化。深度参与全球产业分工和合作，维护多元稳定的国际经济格局和经贸关系。
        </p>
        <p>
          <strong style="font-weight: bolder" data-source="cke">五、实施科教兴国战略，强化现代化建设人才支撑</strong>
        </p>
        <p>
          教育、科技、人才是全面建设社会主义现代化国家的基础性、战略性支撑。必须坚持科技是第一生产力、人才是第一资源、创新是第一动力，深入实施科教兴国战略、人才强国战略、创新驱动发展战略，开辟发展新领域新赛道，不断塑造发展新动能新优势。
        </p>
        <p>
          我们要坚持教育优先发展、科技自立自强、人才引领驱动，加快建设教育强国、科技强国、人才强国，坚持为党育人、为国育才，全面提高人才自主培养质量，着力造就拔尖创新人才，聚天下英才而用之。
        </p>
        <p>
          （一）办好人民满意的教育。教育是国之大计、党之大计。培养什么人、怎样培养人、为谁培养人是教育的根本问题。育人的根本在于立德。全面贯彻党的教育方针，落实立德树人根本任务，培养德智体美劳全面发展的社会主义建设者和接班人。坚持以人民为中心发展教育，加快建设高质量教育体系，发展素质教育，促进教育公平。加快义务教育优质均衡发展和城乡一体化，优化区域教育资源配置，强化学前教育、特殊教育普惠发展，坚持高中阶段学校多样化发展，完善覆盖全学段学生资助体系。统筹职业教育、高等教育、继续教育协同创新，推进职普融通、产教融合、科教融汇，优化职业教育类型定位。加强基础学科、新兴学科、交叉学科建设，加快建设中国特色、世界一流的大学和优势学科。引导规范民办教育发展。加大国家通用语言文字推广力度。深化教育领域综合改革，加强教材建设和管理，完善学校管理和教育评价体系，健全学校家庭社会育人机制。加强师德师风建设，培养高素质教师队伍，弘扬尊师重教社会风尚。推进教育数字化，建设全民终身学习的学习型社会、学习型大国。
        </p>
        <p>
          （二）完善科技创新体系。坚持创新在我国现代化建设全局中的核心地位。完善党中央对科技工作统一领导的体制，健全新型举国体制，强化国家战略科技力量，优化配置创新资源，优化国家科研机构、高水平研究型大学、科技领军企业定位和布局，形成国家实验室体系，统筹推进国际科技创新中心、区域科技创新中心建设，加强科技基础能力建设，强化科技战略咨询，提升国家创新体系整体效能。深化科技体制改革，深化科技评价改革，加大多元化科技投入，加强知识产权法治保障，形成支持全面创新的基础制度。培育创新文化，弘扬科学家精神，涵养优良学风，营造创新氛围。扩大国际科技交流合作，加强国际化科研环境建设，形成具有全球竞争力的开放创新生态。
        </p>
        <p>
          （三）加快实施创新驱动发展战略。坚持面向世界科技前沿、面向经济主战场、面向国家重大需求、面向人民生命健康，加快实现高水平科技自立自强。以国家战略需求为导向，集聚力量进行原创性引领性科技攻关，坚决打赢关键核心技术攻坚战。加快实施一批具有战略性全局性前瞻性的国家重大科技项目，增强自主创新能力。加强基础研究，突出原创，鼓励自由探索。提升科技投入效能，深化财政科技经费分配使用机制改革，激发创新活力。加强企业主导的产学研深度融合，强化目标导向，提高科技成果转化和产业化水平。强化企业科技创新主体地位，发挥科技型骨干企业引领支撑作用，营造有利于科技型中小微企业成长的良好环境，推动创新链产业链资金链人才链深度融合。
        </p>
        <p>
          （四）深入实施人才强国战略。培养造就大批德才兼备的高素质人才，是国家和民族长远发展大计。功以才成，业由才广。坚持党管人才原则，坚持尊重劳动、尊重知识、尊重人才、尊重创造，实施更加积极、更加开放、更加有效的人才政策，引导广大人才爱党报国、敬业奉献、服务人民。完善人才战略布局，坚持各方面人才一起抓，建设规模宏大、结构合理、素质优良的人才队伍。加快建设世界重要人才中心和创新高地，促进人才区域合理布局和协调发展，着力形成人才国际竞争的比较优势。加快建设国家战略人才力量，努力培养造就更多大师、战略科学家、一流科技领军人才和创新团队、青年科技人才、卓越工程师、大国工匠、高技能人才。加强人才国际交流，用好用活各类人才。深化人才发展体制机制改革，真心爱才、悉心育才、倾心引才、精心用才，求贤若渴，不拘一格，把各方面优秀人才集聚到党和人民事业中来。
        </p>
        <p>
          <strong style="font-weight: bolder" data-source="cke">六、发展全过程人民民主，保障人民当家作主</strong>
        </p>
        <p>
          我国是工人阶级领导的、以工农联盟为基础的人民民主专政的社会主义国家，国家一切权力属于人民。人民民主是社会主义的生命，是全面建设社会主义现代化国家的应有之义。全过程人民民主是社会主义民主政治的本质属性，是最广泛、最真实、最管用的民主。必须坚定不移走中国特色社会主义政治发展道路，坚持党的领导、人民当家作主、依法治国有机统一，坚持人民主体地位，充分体现人民意志、保障人民权益、激发人民创造活力。
        </p>
        <p>
          我们要健全人民当家作主制度体系，扩大人民有序政治参与，保证人民依法实行民主选举、民主协商、民主决策、民主管理、民主监督，发挥人民群众积极性、主动性、创造性，巩固和发展生动活泼、安定团结的政治局面。
        </p>
        <p>
          （一）加强人民当家作主制度保障。坚持和完善我国根本政治制度、基本政治制度、重要政治制度，拓展民主渠道，丰富民主形式，确保人民依法通过各种途径和形式管理国家事务，管理经济和文化事业，管理社会事务。支持和保证人民通过人民代表大会行使国家权力，保证各级人大都由民主选举产生、对人民负责、受人民监督。支持和保证人大及其常委会依法行使立法权、监督权、决定权、任免权，健全人大对行政机关、监察机关、审判机关、检察机关监督制度，维护国家法治统一、尊严、权威。加强人大代表工作能力建设，密切人大代表同人民群众的联系。健全吸纳民意、汇集民智工作机制，建设好基层立法联系点。深化工会、共青团、妇联等群团组织改革和建设，有效发挥桥梁纽带作用。坚持走中国人权发展道路，积极参与全球人权治理，推动人权事业全面发展。
        </p>
        <p>
          （二）全面发展协商民主。协商民主是实践全过程人民民主的重要形式。完善协商民主体系，统筹推进政党协商、人大协商、政府协商、政协协商、人民团体协商、基层协商以及社会组织协商，健全各种制度化协商平台，推进协商民主广泛多层制度化发展。坚持和完善中国共产党领导的多党合作和政治协商制度，坚持党的领导、统一战线、协商民主有机结合，坚持发扬民主和增进团结相互贯通、建言资政和凝聚共识双向发力，发挥人民政协作为专门协商机构作用，加强制度化、规范化、程序化等功能建设，提高深度协商互动、意见充分表达、广泛凝聚共识水平，完善人民政协民主监督和委员联系界别群众制度机制。
        </p>
        <p>
          （三）积极发展基层民主。基层民主是全过程人民民主的重要体现。健全基层党组织领导的基层群众自治机制，加强基层组织建设，完善基层直接民主制度体系和工作体系，增强城乡社区群众自我管理、自我服务、自我教育、自我监督的实效。完善办事公开制度，拓宽基层各类群体有序参与基层治理渠道，保障人民依法管理基层公共事务和公益事业。全心全意依靠工人阶级，健全以职工代表大会为基本形式的企事业单位民主管理制度，维护职工合法权益。
        </p>
        <p>
          （四）巩固和发展最广泛的爱国统一战线。人心是最大的政治，统一战线是凝聚人心、汇聚力量的强大法宝。完善大统战工作格局，坚持大团结大联合，动员全体中华儿女围绕实现中华民族伟大复兴中国梦一起来想、一起来干。发挥我国社会主义新型政党制度优势，坚持长期共存、互相监督、肝胆相照、荣辱与共，加强同民主党派和无党派人士的团结合作，支持民主党派加强自身建设、更好履行职能。以铸牢中华民族共同体意识为主线，坚定不移走中国特色解决民族问题的正确道路，坚持和完善民族区域自治制度，加强和改进党的民族工作，全面推进民族团结进步事业。坚持我国宗教中国化方向，积极引导宗教与社会主义社会相适应。加强党外知识分子思想政治工作，做好新的社会阶层人士工作，强化共同奋斗的政治引领。全面构建亲清政商关系，促进非公有制经济健康发展和非公有制经济人士健康成长。加强和改进侨务工作，形成共同致力民族复兴的强大力量。
        </p>
        <p>
          <strong style="font-weight: bolder" data-source="cke">七、坚持全面依法治国，推进法治中国建设</strong>
        </p>
        <p>
          全面依法治国是国家治理的一场深刻革命，关系党执政兴国，关系人民幸福安康，关系党和国家长治久安。必须更好发挥法治固根本、稳预期、利长远的保障作用，在法治轨道上全面建设社会主义现代化国家。
        </p>
        <p>
          我们要坚持走中国特色社会主义法治道路，建设中国特色社会主义法治体系、建设社会主义法治国家，围绕保障和促进社会公平正义，坚持依法治国、依法执政、依法行政共同推进，坚持法治国家、法治政府、法治社会一体建设，全面推进科学立法、严格执法、公正司法、全民守法，全面推进国家各方面工作法治化。
        </p>
        <p>
          （一）完善以宪法为核心的中国特色社会主义法律体系。坚持依法治国首先要坚持依宪治国，坚持依法执政首先要坚持依宪执政，坚持宪法确定的中国共产党领导地位不动摇，坚持宪法确定的人民民主专政的国体和人民代表大会制度的政体不动摇。加强宪法实施和监督，健全保证宪法全面实施的制度体系，更好发挥宪法在治国理政中的重要作用，维护宪法权威。加强重点领域、新兴领域、涉外领域立法，统筹推进国内法治和涉外法治，以良法促进发展、保障善治。推进科学立法、民主立法、依法立法，统筹立改废释纂，增强立法系统性、整体性、协同性、时效性。完善和加强备案审查制度。坚持科学决策、民主决策、依法决策，全面落实重大决策程序制度。
        </p>
        <p>
          （二）扎实推进依法行政。法治政府建设是全面依法治国的重点任务和主体工程。转变政府职能，优化政府职责体系和组织结构，推进机构、职能、权限、程序、责任法定化，提高行政效率和公信力。深化事业单位改革。深化行政执法体制改革，全面推进严格规范公正文明执法，加大关系群众切身利益的重点领域执法力度，完善行政执法程序，健全行政裁量基准。强化行政执法监督机制和能力建设，严格落实行政执法责任制和责任追究制度。完善基层综合执法体制机制。
        </p>
        <p>
          （三）严格公正司法。公正司法是维护社会公平正义的最后一道防线。深化司法体制综合配套改革，全面准确落实司法责任制，加快建设公正高效权威的社会主义司法制度，努力让人民群众在每一个司法案件中感受到公平正义。规范司法权力运行，健全公安机关、检察机关、审判机关、司法行政机关各司其职、相互配合、相互制约的体制机制。强化对司法活动的制约监督，促进司法公正。加强检察机关法律监督工作。完善公益诉讼制度。
        </p>
        <p>
          （四）加快建设法治社会。法治社会是构筑法治国家的基础。弘扬社会主义法治精神，传承中华优秀传统法律文化，引导全体人民做社会主义法治的忠实崇尚者、自觉遵守者、坚定捍卫者。建设覆盖城乡的现代公共法律服务体系，深入开展法治宣传教育，增强全民法治观念。推进多层次多领域依法治理，提升社会治理法治化水平。发挥领导干部示范带头作用，努力使尊法学法守法用法在全社会蔚然成风。
        </p>
        <p>
          <strong style="font-weight: bolder" data-source="cke">八、推进文化自信自强，铸就社会主义文化新辉煌</strong>
        </p>
        <p>
          全面建设社会主义现代化国家，必须坚持中国特色社会主义文化发展道路，增强文化自信，围绕举旗帜、聚民心、育新人、兴文化、展形象建设社会主义文化强国，发展面向现代化、面向世界、面向未来的，民族的科学的大众的社会主义文化，激发全民族文化创新创造活力，增强实现中华民族伟大复兴的精神力量。
        </p>
        <p>
          我们要坚持马克思主义在意识形态领域指导地位的根本制度，坚持为人民服务、为社会主义服务，坚持百花齐放、百家争鸣，坚持创造性转化、创新性发展，以社会主义核心价值观为引领，发展社会主义先进文化，弘扬革命文化，传承中华优秀传统文化，满足人民日益增长的精神文化需求，巩固全党全国各族人民团结奋斗的共同思想基础，不断提升国家文化软实力和中华文化影响力。
        </p>
        <p>
          （一）建设具有强大凝聚力和引领力的社会主义意识形态。意识形态工作是为国家立心、为民族立魂的工作。牢牢掌握党对意识形态工作领导权，全面落实意识形态工作责任制，巩固壮大奋进新时代的主流思想舆论。健全用党的创新理论武装全党、教育人民、指导实践工作体系。深入实施马克思主义理论研究和建设工程，加快构建中国特色哲学社会科学学科体系、学术体系、话语体系，培育壮大哲学社会科学人才队伍。加强全媒体传播体系建设，塑造主流舆论新格局。健全网络综合治理体系，推动形成良好网络生态。
        </p>
        <p>
          （二）广泛践行社会主义核心价值观。社会主义核心价值观是凝聚人心、汇聚民力的强大力量。弘扬以伟大建党精神为源头的中国共产党人精神谱系，用好红色资源，深入开展社会主义核心价值观宣传教育，深化爱国主义、集体主义、社会主义教育，着力培养担当民族复兴大任的时代新人。推动理想信念教育常态化制度化，持续抓好党史、新中国史、改革开放史、社会主义发展史宣传教育，引导人民知史爱党、知史爱国，不断坚定中国特色社会主义共同理想。用社会主义核心价值观铸魂育人，完善思想政治工作体系，推进大中小学思想政治教育一体化建设。坚持依法治国和以德治国相结合，把社会主义核心价值观融入法治建设、融入社会发展、融入日常生活。
        </p>
        <p>
          （三）提高全社会文明程度。实施公民道德建设工程，弘扬中华传统美德，加强家庭家教家风建设，加强和改进未成年人思想道德建设，推动明大德、守公德、严私德，提高人民道德水准和文明素养。统筹推动文明培育、文明实践、文明创建，推进城乡精神文明建设融合发展，在全社会弘扬劳动精神、奋斗精神、奉献精神、创造精神、勤俭节约精神，培育时代新风新貌。加强国家科普能力建设，深化全民阅读活动。完善志愿服务制度和工作体系。弘扬诚信文化，健全诚信建设长效机制。发挥党和国家功勋荣誉表彰的精神引领、典型示范作用，推动全社会见贤思齐、崇尚英雄、争做先锋。
        </p>
        <p>
          （四）繁荣发展文化事业和文化产业。坚持以人民为中心的创作导向，推出更多增强人民精神力量的优秀作品，培育造就大批德艺双馨的文学艺术家和规模宏大的文化文艺人才队伍。坚持把社会效益放在首位、社会效益和经济效益相统一，深化文化体制改革，完善文化经济政策。实施国家文化数字化战略，健全现代公共文化服务体系，创新实施文化惠民工程。健全现代文化产业体系和市场体系，实施重大文化产业项目带动战略。加大文物和文化遗产保护力度，加强城乡建设中历史文化保护传承，建好用好国家文化公园。坚持以文塑旅、以旅彰文，推进文化和旅游深度融合发展。广泛开展全民健身活动，加强青少年体育工作，促进群众体育和竞技体育全面发展，加快建设体育强国。
        </p>
        <p>
          （五）增强中华文明传播力影响力。坚守中华文化立场，提炼展示中华文明的精神标识和文化精髓，加快构建中国话语和中国叙事体系，讲好中国故事、传播好中国声音，展现可信、可爱、可敬的中国形象。加强国际传播能力建设，全面提升国际传播效能，形成同我国综合国力和国际地位相匹配的国际话语权。深化文明交流互鉴，推动中华文化更好走向世界。
        </p>
        <p>
          <strong style="font-weight: bolder" data-source="cke">九、增进民生福祉，提高人民生活品质</strong>
        </p>
        <p>
          江山就是人民，人民就是江山。中国共产党领导人民打江山、守江山，守的是人民的心。治国有常，利民为本。为民造福是立党为公、执政为民的本质要求。必须坚持在发展中保障和改善民生，鼓励共同奋斗创造美好生活，不断实现人民对美好生活的向往。
        </p>
        <p>
          我们要实现好、维护好、发展好最广大人民根本利益，紧紧抓住人民最关心最直接最现实的利益问题，坚持尽力而为、量力而行，深入群众、深入基层，采取更多惠民生、暖民心举措，着力解决好人民群众急难愁盼问题，健全基本公共服务体系，提高公共服务水平，增强均衡性和可及性，扎实推进共同富裕。
        </p>
        <p>
          （一）完善分配制度。分配制度是促进共同富裕的基础性制度。坚持按劳分配为主体、多种分配方式并存，构建初次分配、再分配、第三次分配协调配套的制度体系。努力提高居民收入在国民收入分配中的比重，提高劳动报酬在初次分配中的比重。坚持多劳多得，鼓励勤劳致富，促进机会公平，增加低收入者收入，扩大中等收入群体。完善按要素分配政策制度，探索多种渠道增加中低收入群众要素收入，多渠道增加城乡居民财产性收入。加大税收、社会保障、转移支付等的调节力度。完善个人所得税制度，规范收入分配秩序，规范财富积累机制，保护合法收入，调节过高收入，取缔非法收入。引导、支持有意愿有能力的企业、社会组织和个人积极参与公益慈善事业。
        </p>
        <p>
          （二）实施就业优先战略。就业是最基本的民生。强化就业优先政策，健全就业促进机制，促进高质量充分就业。健全就业公共服务体系，完善重点群体就业支持体系，加强困难群体就业兜底帮扶。统筹城乡就业政策体系，破除妨碍劳动力、人才流动的体制和政策弊端，消除影响平等就业的不合理限制和就业歧视，使人人都有通过勤奋劳动实现自身发展的机会。健全终身职业技能培训制度，推动解决结构性就业矛盾。完善促进创业带动就业的保障制度，支持和规范发展新就业形态。健全劳动法律法规，完善劳动关系协商协调机制，完善劳动者权益保障制度，加强灵活就业和新就业形态劳动者权益保障。
        </p>
        <p>
          （三）健全社会保障体系。社会保障体系是人民生活的安全网和社会运行的稳定器。健全覆盖全民、统筹城乡、公平统一、安全规范、可持续的多层次社会保障体系。完善基本养老保险全国统筹制度，发展多层次、多支柱养老保险体系。实施渐进式延迟法定退休年龄。扩大社会保险覆盖面，健全基本养老、基本医疗保险筹资和待遇调整机制，推动基本医疗保险、失业保险、工伤保险省级统筹。促进多层次医疗保障有序衔接，完善大病保险和医疗救助制度，落实异地就医结算，建立长期护理保险制度，积极发展商业医疗保险。加快完善全国统一的社会保险公共服务平台。健全社保基金保值增值和安全监管体系。健全分层分类的社会救助体系。坚持男女平等基本国策，保障妇女儿童合法权益。完善残疾人社会保障制度和关爱服务体系，促进残疾人事业全面发展。坚持房子是用来住的、不是用来炒的定位，加快建立多主体供给、多渠道保障、租购并举的住房制度。
        </p>
        <p>
          （四）推进健康中国建设。人民健康是民族昌盛和国家强盛的重要标志。把保障人民健康放在优先发展的战略位置，完善人民健康促进政策。优化人口发展战略，建立生育支持政策体系，降低生育、养育、教育成本。实施积极应对人口老龄化国家战略，发展养老事业和养老产业，优化孤寡老人服务，推动实现全体老年人享有基本养老服务。深化医药卫生体制改革，促进医保、医疗、医药协同发展和治理。促进优质医疗资源扩容和区域均衡布局，坚持预防为主，加强重大慢性病健康管理，提高基层防病治病和健康管理能力。深化以公益性为导向的公立医院改革，规范民营医院发展。发展壮大医疗卫生队伍，把工作重点放在农村和社区。重视心理健康和精神卫生。促进中医药传承创新发展。创新医防协同、医防融合机制，健全公共卫生体系，提高重大疫情早发现能力，加强重大疫情防控救治体系和应急能力建设，有效遏制重大传染性疾病传播。深入开展健康中国行动和爱国卫生运动，倡导文明健康生活方式。
        </p>
        <p>
          <strong style="font-weight: bolder" data-source="cke">十、推动绿色发展，促进人与自然和谐共生</strong>
        </p>
        <p>
          大自然是人类赖以生存发展的基本条件。尊重自然、顺应自然、保护自然，是全面建设社会主义现代化国家的内在要求。必须牢固树立和践行绿水青山就是金山银山的理念，站在人与自然和谐共生的高度谋划发展。
        </p>
        <p>
          我们要推进美丽中国建设，坚持山水林田湖草沙一体化保护和系统治理，统筹产业结构调整、污染治理、生态保护、应对气候变化，协同推进降碳、减污、扩绿、增长，推进生态优先、节约集约、绿色低碳发展。
        </p>
        <p>
          （一）加快发展方式绿色转型。推动经济社会发展绿色化、低碳化是实现高质量发展的关键环节。加快推动产业结构、能源结构、交通运输结构等调整优化。实施全面节约战略，推进各类资源节约集约利用，加快构建废弃物循环利用体系。完善支持绿色发展的财税、金融、投资、价格政策和标准体系，发展绿色低碳产业，健全资源环境要素市场化配置体系，加快节能降碳先进技术研发和推广应用，倡导绿色消费，推动形成绿色低碳的生产方式和生活方式。
        </p>
        <p>
          （二）深入推进环境污染防治。坚持精准治污、科学治污、依法治污，持续深入打好蓝天、碧水、净土保卫战。加强污染物协同控制，基本消除重污染天气。统筹水资源、水环境、水生态治理，推动重要江河湖库生态保护治理，基本消除城市黑臭水体。加强土壤污染源头防控，开展新污染物治理。提升环境基础设施建设水平，推进城乡人居环境整治。全面实行排污许可制，健全现代环境治理体系。严密防控环境风险。深入推进中央生态环境保护督察。
        </p>
        <p>
          （三）提升生态系统多样性、稳定性、持续性。以国家重点生态功能区、生态保护红线、自然保护地等为重点，加快实施重要生态系统保护和修复重大工程。推进以国家公园为主体的自然保护地体系建设。实施生物多样性保护重大工程。科学开展大规模国土绿化行动。深化集体林权制度改革。推行草原森林河流湖泊湿地休养生息，实施好长江十年禁渔，健全耕地休耕轮作制度。建立生态产品价值实现机制，完善生态保护补偿制度。加强生物安全管理，防治外来物种侵害。
        </p>
        <p>
          （四）积极稳妥推进碳达峰碳中和。实现碳达峰碳中和是一场广泛而深刻的经济社会系统性变革。立足我国能源资源禀赋，坚持先立后破，有计划分步骤实施碳达峰行动。完善能源消耗总量和强度调控，重点控制化石能源消费，逐步转向碳排放总量和强度“双控”制度。推动能源清洁低碳高效利用，推进工业、建筑、交通等领域清洁低碳转型。深入推进能源革命，加强煤炭清洁高效利用，加大油气资源勘探开发和增储上产力度，加快规划建设新型能源体系，统筹水电开发和生态保护，积极安全有序发展核电，加强能源产供储销体系建设，确保能源安全。完善碳排放统计核算制度，健全碳排放权市场交易制度。提升生态系统碳汇能力。积极参与应对气候变化全球治理。
        </p>
        <p>
          <strong style="font-weight: bolder" data-source="cke">十一、推进国家安全体系和能力现代化，坚决维护国家安全和社会稳定</strong>
        </p>
        <p>
          国家安全是民族复兴的根基，社会稳定是国家强盛的前提。必须坚定不移贯彻总体国家安全观，把维护国家安全贯穿党和国家工作各方面全过程，确保国家安全和社会稳定。
        </p>
        <p>
          我们要坚持以人民安全为宗旨、以政治安全为根本、以经济安全为基础、以军事科技文化社会安全为保障、以促进国际安全为依托，统筹外部安全和内部安全、国土安全和国民安全、传统安全和非传统安全、自身安全和共同安全，统筹维护和塑造国家安全，夯实国家安全和社会稳定基层基础，完善参与全球安全治理机制，建设更高水平的平安中国，以新安全格局保障新发展格局。
        </p>
        <p>
          （一）健全国家安全体系。坚持党中央对国家安全工作的集中统一领导，完善高效权威的国家安全领导体制。强化国家安全工作协调机制，完善国家安全法治体系、战略体系、政策体系、风险监测预警体系、国家应急管理体系，完善重点领域安全保障体系和重要专项协调指挥体系，强化经济、重大基础设施、金融、网络、数据、生物、资源、核、太空、海洋等安全保障体系建设。健全反制裁、反干涉、反“长臂管辖”机制。完善国家安全力量布局，构建全域联动、立体高效的国家安全防护体系。
        </p>
        <p>
          （二）增强维护国家安全能力。坚定维护国家政权安全、制度安全、意识形态安全，加强重点领域安全能力建设，确保粮食、能源资源、重要产业链供应链安全，加强海外安全保障能力建设，维护我国公民、法人在海外合法权益，维护海洋权益，坚定捍卫国家主权、安全、发展利益。提高防范化解重大风险能力，严密防范系统性安全风险，严厉打击敌对势力渗透、破坏、颠覆、分裂活动。全面加强国家安全教育，提高各级领导干部统筹发展和安全能力，增强全民国家安全意识和素养，筑牢国家安全人民防线。
        </p>
        <p>
          （三）提高公共安全治理水平。坚持安全第一、预防为主，建立大安全大应急框架，完善公共安全体系，推动公共安全治理模式向事前预防转型。推进安全生产风险专项整治，加强重点行业、重点领域安全监管。提高防灾减灾救灾和重大突发公共事件处置保障能力，加强国家区域应急力量建设。强化食品药品安全监管，健全生物安全监管预警防控体系。加强个人信息保护。
        </p>
        <p>
          （四）完善社会治理体系。健全共建共治共享的社会治理制度，提升社会治理效能。在社会基层坚持和发展新时代“枫桥经验”，完善正确处理新形势下人民内部矛盾机制，加强和改进人民信访工作，畅通和规范群众诉求表达、利益协调、权益保障通道，完善网格化管理、精细化服务、信息化支撑的基层治理平台，健全城乡社区治理体系，及时把矛盾纠纷化解在基层、化解在萌芽状态。加快推进市域社会治理现代化，提高市域社会治理能力。强化社会治安整体防控，推进扫黑除恶常态化，依法严惩群众反映强烈的各类违法犯罪活动。发展壮大群防群治力量，营造见义勇为社会氛围，建设人人有责、人人尽责、人人享有的社会治理共同体。
        </p>
        <p>
          <strong style="font-weight: bolder" data-source="cke">十二、实现建军一百年奋斗目标，开创国防和军队现代化新局面</strong>
        </p>
        <p>
          如期实现建军一百年奋斗目标，加快把人民军队建成世界一流军队，是全面建设社会主义现代化国家的战略要求。必须贯彻新时代党的强军思想，贯彻新时代军事战略方针，坚持党对人民军队的绝对领导，坚持政治建军、改革强军、科技强军、人才强军、依法治军，坚持边斗争、边备战、边建设，坚持机械化信息化智能化融合发展，加快军事理论现代化、军队组织形态现代化、军事人员现代化、武器装备现代化，提高捍卫国家主权、安全、发展利益战略能力，有效履行新时代人民军队使命任务。
        </p>
        <p>
          全面加强人民军队党的建设，确保枪杆子永远听党指挥。健全贯彻军委主席负责制体制机制。深化党的创新理论武装，开展“学习强军思想、建功强军事业”教育实践活动。加强军史学习教育，繁荣发展强军文化，强化战斗精神培育。建强人民军队党的组织体系，推进政治整训常态化制度化，持之以恒正风肃纪反腐。
        </p>
        <p>
          全面加强练兵备战，提高人民军队打赢能力。研究掌握信息化智能化战争特点规律，创新军事战略指导，发展人民战争战略战术。打造强大战略威慑力量体系，增加新域新质作战力量比重，加快无人智能作战力量发展，统筹网络信息体系建设运用。优化联合作战指挥体系，推进侦察预警、联合打击、战场支撑、综合保障体系和能力建设。深入推进实战化军事训练，深化联合训练、对抗训练、科技练兵。加强军事力量常态化多样化运用，坚定灵活开展军事斗争，塑造安全态势，遏控危机冲突，打赢局部战争。
        </p>
        <p>
          全面加强军事治理，巩固拓展国防和军队改革成果，完善军事力量结构编成，体系优化军事政策制度。加强国防和军队建设重大任务战建备统筹，加快建设现代化后勤，实施国防科技和武器装备重大工程，加速科技向战斗力转化。深化军队院校改革，建强新型军事人才培养体系，创新军事人力资源管理。加强依法治军机制建设和战略规划，完善中国特色军事法治体系。改进战略管理，提高军事系统运行效能和国防资源使用效益。
        </p>
        <p>
          巩固提高一体化国家战略体系和能力。加强军地战略规划统筹、政策制度衔接、资源要素共享。优化国防科技工业体系和布局，加强国防科技工业能力建设。深化全民国防教育。加强国防动员和后备力量建设，推进现代边海空防建设。加强军人军属荣誉激励和权益保障，做好退役军人服务保障工作。巩固发展军政军民团结。
        </p>
        <p>
          人民军队始终是党和人民完全可以信赖的英雄军队，有信心、有能力维护国家主权、统一和领土完整，有信心、有能力为实现中华民族伟大复兴提供战略支撑，有信心、有能力为世界和平与发展作出更大贡献！
        </p>
        <p>
          <strong style="font-weight: bolder" data-source="cke">十三、坚持和完善“一国两制”，推进祖国统一</strong>
        </p>
        <p>
          “一国两制”是中国特色社会主义的伟大创举，是香港、澳门回归后保持长期繁荣稳定的最佳制度安排，必须长期坚持。
        </p>
        <p>
          全面准确、坚定不移贯彻“一国两制”、“港人治港”、“澳人治澳”、高度自治的方针，坚持依法治港治澳，维护宪法和基本法确定的特别行政区宪制秩序。坚持和完善“一国两制”制度体系，落实中央全面管治权，落实“爱国者治港”、“爱国者治澳”原则，落实特别行政区维护国家安全的法律制度和执行机制。坚持中央全面管治权和保障特别行政区高度自治权相统一，坚持行政主导，支持行政长官和特别行政区政府依法施政，提升全面治理能力和管治水平，完善特别行政区司法制度和法律体系，保持香港、澳门资本主义制度和生活方式长期不变，促进香港、澳门长期繁荣稳定。
        </p>
        <p>
          支持香港、澳门发展经济、改善民生、破解经济社会发展中的深层次矛盾和问题。发挥香港、澳门优势和特点，巩固提升香港、澳门在国际金融、贸易、航运航空、创新科技、文化旅游等领域的地位，深化香港、澳门同各国各地区更加开放、更加密切的交往合作。推进粤港澳大湾区建设，支持香港、澳门更好融入国家发展大局，为实现中华民族伟大复兴更好发挥作用。
        </p>
        <p>
          发展壮大爱国爱港爱澳力量，增强港澳同胞的爱国精神，形成更广泛的国内外支持“一国两制”的统一战线。坚决打击反中乱港乱澳势力，坚决防范和遏制外部势力干预港澳事务。
        </p>
        <p>
          解决台湾问题、实现祖国完全统一，是党矢志不渝的历史任务，是全体中华儿女的共同愿望，是实现中华民族伟大复兴的必然要求。坚持贯彻新时代党解决台湾问题的总体方略，牢牢把握两岸关系主导权和主动权，坚定不移推进祖国统一大业。
        </p>
        <p>
          “和平统一、一国两制”方针是实现两岸统一的最佳方式，对两岸同胞和中华民族最有利。我们坚持一个中国原则和“九二共识”，在此基础上，推进同台湾各党派、各界别、各阶层人士就两岸关系和国家统一开展广泛深入协商，共同推动两岸关系和平发展、推进祖国和平统一进程。我们坚持团结广大台湾同胞，坚定支持岛内爱国统一力量，共同把握历史大势，坚守民族大义，坚定反“独”促统。伟大祖国永远是所有爱国统一力量的坚强后盾！
        </p>
        <p>
          两岸同胞血脉相连，是血浓于水的一家人。我们始终尊重、关爱、造福台湾同胞，继续致力于促进两岸经济文化交流合作，深化两岸各领域融合发展，完善增进台湾同胞福祉的制度和政策，推动两岸共同弘扬中华文化，促进两岸同胞心灵契合。
        </p>
        <p>
          台湾是中国的台湾。解决台湾问题是中国人自己的事，要由中国人来决定。我们坚持以最大诚意、尽最大努力争取和平统一的前景，但决不承诺放弃使用武力，保留采取一切必要措施的选项，这针对的是外部势力干涉和极少数“台独”分裂分子及其分裂活动，绝非针对广大台湾同胞。国家统一、民族复兴的历史车轮滚滚向前，祖国完全统一一定要实现，也一定能够实现！
        </p>
        <p>
          <strong style="font-weight: bolder" data-source="cke">十四、促进世界和平与发展，推动构建人类命运共同体</strong>
        </p>
        <p>
          当前，世界之变、时代之变、历史之变正以前所未有的方式展开。一方面，和平、发展、合作、共赢的历史潮流不可阻挡，人心所向、大势所趋决定了人类前途终归光明。另一方面，恃强凌弱、巧取豪夺、零和博弈等霸权霸道霸凌行径危害深重，和平赤字、发展赤字、安全赤字、治理赤字加重，人类社会面临前所未有的挑战。世界又一次站在历史的十字路口，何去何从取决于各国人民的抉择。
        </p>
        <p>
          中国始终坚持维护世界和平、促进共同发展的外交政策宗旨，致力于推动构建人类命运共同体。
        </p>
        <p>
          中国坚定奉行独立自主的和平外交政策，始终根据事情本身的是非曲直决定自己的立场和政策，维护国际关系基本准则，维护国际公平正义。中国尊重各国主权和领土完整，坚持国家不分大小、强弱、贫富一律平等，尊重各国人民自主选择的发展道路和社会制度，坚决反对一切形式的霸权主义和强权政治，反对冷战思维，反对干涉别国内政，反对搞双重标准。中国奉行防御性的国防政策，中国的发展是世界和平力量的增长，无论发展到什么程度，中国永远不称霸、永远不搞扩张。
        </p>
        <p>
          中国坚持在和平共处五项原则基础上同各国发展友好合作，推动构建新型国际关系，深化拓展平等、开放、合作的全球伙伴关系，致力于扩大同各国利益的汇合点。促进大国协调和良性互动，推动构建和平共处、总体稳定、均衡发展的大国关系格局。坚持亲诚惠容和与邻为善、以邻为伴周边外交方针，深化同周边国家友好互信和利益融合。秉持真实亲诚理念和正确义利观加强同发展中国家团结合作，维护发展中国家共同利益。中国共产党愿在独立自主、完全平等、互相尊重、互不干涉内部事务原则基础上加强同各国政党和政治组织交流合作，积极推进人大、政协、军队、地方、民间等各方面对外交往。
        </p>
        <p>
          中国坚持对外开放的基本国策，坚定奉行互利共赢的开放战略，不断以中国新发展为世界提供新机遇，推动建设开放型世界经济，更好惠及各国人民。中国坚持经济全球化正确方向，推动贸易和投资自由化便利化，推进双边、区域和多边合作，促进国际宏观经济政策协调，共同营造有利于发展的国际环境，共同培育全球发展新动能，反对保护主义，反对“筑墙设垒”、“脱钩断链”，反对单边制裁、极限施压。中国愿加大对全球发展合作的资源投入，致力于缩小南北差距，坚定支持和帮助广大发展中国家加快发展。
        </p>
        <p>
          中国积极参与全球治理体系改革和建设，践行共商共建共享的全球治理观，坚持真正的多边主义，推进国际关系民主化，推动全球治理朝着更加公正合理的方向发展。坚定维护以联合国为核心的国际体系、以国际法为基础的国际秩序、以联合国宪章宗旨和原则为基础的国际关系基本准则，反对一切形式的单边主义，反对搞针对特定国家的阵营化和排他性小圈子。推动世界贸易组织、亚太经合组织等多边机制更好发挥作用，扩大金砖国家、上海合作组织等合作机制影响力，增强新兴市场国家和发展中国家在全球事务中的代表性和发言权。中国坚持积极参与全球安全规则制定，加强国际安全合作，积极参与联合国维和行动，为维护世界和平和地区稳定发挥建设性作用。
        </p>
        <p>
          构建人类命运共同体是世界各国人民前途所在。万物并育而不相害，道并行而不相悖。只有各国行天下之大道，和睦相处、合作共赢，繁荣才能持久，安全才有保障。中国提出了全球发展倡议、全球安全倡议，愿同国际社会一道努力落实。中国坚持对话协商，推动建设一个持久和平的世界；坚持共建共享，推动建设一个普遍安全的世界；坚持合作共赢，推动建设一个共同繁荣的世界；坚持交流互鉴，推动建设一个开放包容的世界；坚持绿色低碳，推动建设一个清洁美丽的世界。
        </p>
        <p>
          我们真诚呼吁，世界各国弘扬和平、发展、公平、正义、民主、自由的全人类共同价值，促进各国人民相知相亲，尊重世界文明多样性，以文明交流超越文明隔阂、文明互鉴超越文明冲突、文明共存超越文明优越，共同应对各种全球性挑战。
        </p>
        <p>
          我们所处的是一个充满挑战的时代，也是一个充满希望的时代。中国人民愿同世界人民携手开创人类更加美好的未来！
        </p>
        <p>
          <strong style="font-weight: bolder" data-source="cke">十五、坚定不移全面从严治党，深入推进新时代党的建设新的伟大工程</strong>
        </p>
        <p>
          全面建设社会主义现代化国家、全面推进中华民族伟大复兴，关键在党。我们党作为世界上最大的马克思主义执政党，要始终赢得人民拥护、巩固长期执政地位，必须时刻保持解决大党独有难题的清醒和坚定。经过十八大以来全面从严治党，我们解决了党内许多突出问题，但党面临的执政考验、改革开放考验、市场经济考验、外部环境考验将长期存在，精神懈怠危险、能力不足危险、脱离群众危险、消极腐败危险将长期存在。全党必须牢记，全面从严治党永远在路上，党的自我革命永远在路上，决不能有松劲歇脚、疲劳厌战的情绪，必须持之以恒推进全面从严治党，深入推进新时代党的建设新的伟大工程，以党的自我革命引领社会革命。
        </p>
        <p>
          我们要落实新时代党的建设总要求，健全全面从严治党体系，全面推进党的自我净化、自我完善、自我革新、自我提高，使我们党坚守初心使命，始终成为中国特色社会主义事业的坚强领导核心。
        </p>
        <p>
          （一）坚持和加强党中央集中统一领导。党的领导是全面的、系统的、整体的，必须全面、系统、整体加以落实。健全总揽全局、协调各方的党的领导制度体系，完善党中央重大决策部署落实机制，确保全党在政治立场、政治方向、政治原则、政治道路上同党中央保持高度一致，确保党的团结统一。完善党中央决策议事协调机构，加强党中央对重大工作的集中统一领导。加强党的政治建设，严明政治纪律和政治规矩，落实各级党委（党组）主体责任，提高各级党组织和党员干部政治判断力、政治领悟力、政治执行力。坚持科学执政、民主执政、依法执政，贯彻民主集中制，创新和改进领导方式，提高党把方向、谋大局、定政策、促改革能力，调动各方面积极性。增强党内政治生活政治性、时代性、原则性、战斗性，用好批评和自我批评武器，持续净化党内政治生态。
        </p>
        <p>
          （二）坚持不懈用新时代中国特色社会主义思想凝心铸魂。用党的创新理论武装全党是党的思想建设的根本任务。全面加强党的思想建设，坚持用新时代中国特色社会主义思想统一思想、统一意志、统一行动，组织实施党的创新理论学习教育计划，建设马克思主义学习型政党。加强理想信念教育，引导全党牢记党的宗旨，解决好世界观、人生观、价值观这个总开关问题，自觉做共产主义远大理想和中国特色社会主义共同理想的坚定信仰者和忠实实践者。坚持学思用贯通、知信行统一，把新时代中国特色社会主义思想转化为坚定理想、锤炼党性和指导实践、推动工作的强大力量。坚持理论武装同常态化长效化开展党史学习教育相结合，引导党员、干部不断学史明理、学史增信、学史崇德、学史力行，传承红色基因，赓续红色血脉。以县处级以上领导干部为重点在全党深入开展主题教育。
        </p>
        <p>
          （三）完善党的自我革命制度规范体系。坚持制度治党、依规治党，以党章为根本，以民主集中制为核心，完善党内法规制度体系，增强党内法规权威性和执行力，形成坚持真理、修正错误，发现问题、纠正偏差的机制。健全党统一领导、全面覆盖、权威高效的监督体系，完善权力监督制约机制，以党内监督为主导，促进各类监督贯通协调，让权力在阳光下运行。推进政治监督具体化、精准化、常态化，增强对“一把手”和领导班子监督实效。发挥政治巡视利剑作用，加强巡视整改和成果运用。落实全面从严治党政治责任，用好问责利器。
        </p>
        <p>
          （四）建设堪当民族复兴重任的高素质干部队伍。全面建设社会主义现代化国家，必须有一支政治过硬、适应新时代要求、具备领导现代化建设能力的干部队伍。坚持党管干部原则，坚持德才兼备、以德为先、五湖四海、任人唯贤，把新时代好干部标准落到实处。树立选人用人正确导向，选拔忠诚干净担当的高素质专业化干部，选优配强各级领导班子。坚持把政治标准放在首位，做深做实干部政治素质考察，突出把好政治关、廉洁关。加强实践锻炼、专业训练，注重在重大斗争中磨砺干部，增强干部推动高质量发展本领、服务群众本领、防范化解风险本领。加强干部斗争精神和斗争本领养成，着力增强防风险、迎挑战、抗打压能力，带头担当作为，做到平常时候看得出来、关键时刻站得出来、危难关头豁得出来。完善干部考核评价体系，引导干部树立和践行正确政绩观，推动干部能上能下、能进能出，形成能者上、优者奖、庸者下、劣者汰的良好局面。抓好后继有人这个根本大计，健全培养选拔优秀年轻干部常态化工作机制，把到基层和艰苦地区锻炼成长作为年轻干部培养的重要途径。重视女干部培养选拔工作，发挥女干部重要作用。重视培养和用好少数民族干部，统筹做好党外干部工作。做好离退休干部工作。加强和改进公务员工作，优化机构编制资源配置。坚持严管和厚爱相结合，加强对干部全方位管理和经常性监督，落实“三个区分开来”，激励干部敢于担当、积极作为。关心关爱基层干部特别是条件艰苦地区干部。
        </p>
        <p>
          （五）增强党组织政治功能和组织功能。严密的组织体系是党的优势所在、力量所在。各级党组织要履行党章赋予的各项职责，把党的路线方针政策和党中央决策部署贯彻落实好，把各领域广大群众组织凝聚好。坚持大抓基层的鲜明导向，抓党建促乡村振兴，加强城市社区党建工作，推进以党建引领基层治理，持续整顿软弱涣散基层党组织，把基层党组织建设成为有效实现党的领导的坚强战斗堡垒。全面提高机关党建质量，推进事业单位党建工作。推进国有企业、金融企业在完善公司治理中加强党的领导，加强混合所有制企业、非公有制企业党建工作，理顺行业协会、学会、商会党建工作管理体制。加强新经济组织、新社会组织、新就业群体党的建设。注重从青年和产业工人、农民、知识分子中发展党员，加强和改进党员特别是流动党员教育管理。落实党内民主制度，保障党员权利，激励党员发挥先锋模范作用。严肃稳妥处置不合格党员，保持党员队伍先进性和纯洁性。
        </p>
        <p>
          （六）坚持以严的基调强化正风肃纪。党风问题关系执政党的生死存亡。弘扬党的光荣传统和优良作风，促进党员干部特别是领导干部带头深入调查研究，扑下身子干实事、谋实招、求实效。锲而不舍落实中央八项规定精神，抓住“关键少数”以上率下，持续深化纠治“四风”，重点纠治形式主义、官僚主义，坚决破除特权思想和特权行为。把握作风建设地区性、行业性、阶段性特点，抓住普遍发生、反复出现的问题深化整治，推进作风建设常态化长效化。全面加强党的纪律建设，督促领导干部特别是高级干部严于律己、严负其责、严管所辖，对违反党纪的问题，发现一起坚决查处一起。坚持党性党风党纪一起抓，从思想上固本培元，提高党性觉悟，增强拒腐防变能力，涵养富贵不能淫、贫贱不能移、威武不能屈的浩然正气。
        </p>
        <p>
          （七）坚决打赢反腐败斗争攻坚战持久战。腐败是危害党的生命力和战斗力的最大毒瘤，反腐败是最彻底的自我革命。只要存在腐败问题产生的土壤和条件，反腐败斗争就一刻不能停，必须永远吹冲锋号。坚持不敢腐、不能腐、不想腐一体推进，同时发力、同向发力、综合发力。以零容忍态度反腐惩恶，更加有力遏制增量，更加有效清除存量，坚决查处政治问题和经济问题交织的腐败，坚决防止领导干部成为利益集团和权势团体的代言人、代理人，坚决治理政商勾连破坏政治生态和经济发展环境问题，决不姑息。深化整治权力集中、资金密集、资源富集领域的腐败，坚决惩治群众身边的“蝇贪”，严肃查处领导干部配偶、子女及其配偶等亲属和身边工作人员利用影响力谋私贪腐问题，坚持受贿行贿一起查，惩治新型腐败和隐性腐败。深化反腐败国际合作，一体构建追逃防逃追赃机制。深化标本兼治，推进反腐败国家立法，加强新时代廉洁文化建设，教育引导广大党员、干部增强不想腐的自觉，清清白白做人、干干净净做事，使严厉惩治、规范权力、教育引导紧密结合、协调联动，不断取得更多制度性成果和更大治理效能。
        </p>
        <p>
          同志们！时代呼唤着我们，人民期待着我们，唯有矢志不渝、笃行不怠，方能不负时代、不负人民。全党必须牢记，坚持党的全面领导是坚持和发展中国特色社会主义的必由之路，中国特色社会主义是实现中华民族伟大复兴的必由之路，团结奋斗是中国人民创造历史伟业的必由之路，贯彻新发展理念是新时代我国发展壮大的必由之路，全面从严治党是党永葆生机活力、走好新的赶考之路的必由之路。这是我们在长期实践中得出的至关紧要的规律性认识，必须倍加珍惜、始终坚持，咬定青山不放松，引领和保障中国特色社会主义巍巍巨轮乘风破浪、行稳致远。
        </p>
        <p>
          团结就是力量，团结才能胜利。全面建设社会主义现代化国家，必须充分发挥亿万人民的创造伟力。全党要坚持全心全意为人民服务的根本宗旨，树牢群众观点，贯彻群众路线，尊重人民首创精神，坚持一切为了人民、一切依靠人民，从群众中来、到群众中去，始终保持同人民群众的血肉联系，始终接受人民批评和监督，始终同人民同呼吸、共命运、心连心，不断巩固全国各族人民大团结，加强海内外中华儿女大团结，形成同心共圆中国梦的强大合力。
        </p>
        <p>
          青年强，则国家强。当代中国青年生逢其时，施展才干的舞台无比广阔，实现梦想的前景无比光明。全党要把青年工作作为战略性工作来抓，用党的科学理论武装青年，用党的初心使命感召青年，做青年朋友的知心人、青年工作的热心人、青年群众的引路人。广大青年要坚定不移听党话、跟党走，怀抱梦想又脚踏实地，敢想敢为又善作善成，立志做有理想、敢担当、能吃苦、肯奋斗的新时代好青年，让青春在全面建设社会主义现代化国家的火热实践中绽放绚丽之花。
        </p>
        <p>
          同志们！党用伟大奋斗创造了百年伟业，也一定能用新的伟大奋斗创造新的伟业。全党全军全国各族人民要紧密团结在党中央周围，牢记空谈误国、实干兴邦，坚定信心、同心同德，埋头苦干、奋勇前进，为全面建设社会主义现代化国家、全面推进中华民族伟大复兴而团结奋斗！
        </p>
        <p style="text-indent: 0; font-weight: 700">来源:中央政法委长安剑</p>
        <p style="text-indent: 0; font-weight: 700">
          声明:转载此文是出于传递更多信息、利于普法之目的。若有来源标注错误或侵犯了您的合法权益，请作者持权属证明与广东东进联系，我们将及时更正、删除，谢谢。
        </p>
      </div>
      <br />
      <br />
      <el-row :gutter="20">
        <el-col :span="12" :xs="24" :offset="0">
          <span style="cursor: pointer; color: #666; font-size: 14px" @click="$router.push({ name: 'Build2' })">&lt;
            上一条&nbsp;&nbsp;&nbsp;&nbsp;党的二十大主题的深邃意蕴</span>
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" style="text-align: right" class="hidden-xs-only">
          <span style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'Build0' })">中国共产党章程&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span>
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" class="hidden-sm-and-up">
          <span style="cursor: pointer; color: #666; font-size: 14px" @click="$router.push({ name: 'Build0' })">下一条 &gt;
            &nbsp;&nbsp;&nbsp;&nbsp;中国共产党章程</span>
        </el-col>
      </el-row>
      <br />
      <br />
    </el-card>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        img: [require('@/assets/news5.png')]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .kongxi {
    height: 10px;
  }

  .content {
    width: 90%;
    margin: 0 auto;

    h2 {
      font-family: 黑体, SimHei;
      font-size: 24px;
      margin: 20px 0;
      text-align: center;
    }

    p {
      font-size: 16px;
      margin: 20px 0;
      text-align: justify;
      text-indent: 2em;
      color: #515050;
      font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
    }
  }

  @media screen and (max-width: 768px) {
    .content {
      width: 90%;
      margin: 0 auto;

      h2 {
        font-family: 黑体, SimHei;
        font-size: 24px;
        margin: 20px 0;
        text-align: center;
      }

      p {
        font-size: 16px;
        margin: 20px 0;
        text-align: justify;
        text-indent: 2em;
        color: #515050;
        font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
      }
    }
  }
</style>